import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Pedido/eliminarPedidoSeleccion`, method: 'POST', body: {list}, token: token})
}